<template>
  <TermsPage type="countries" name="Countries" :slug="$route.params.slug" />
</template>
